import './DeliveryOptionForm.scss';

import { GridCell as Cell, Grid, GridRow as Row } from '@rmwc/grid';
import { TextField, TextFieldHelperText as HelperText } from '@rmwc/textfield';
import { Checkbox } from '@rmwc/checkbox';
import { Select } from '@rmwc/select';
import React from 'react';
import { convertTimeFromSeconds, convertTimeToSeconds } from '../../utils/time';

const DeliveryOptionForm = ({ deliveryOptionChanged, newDelivery, loading }) => {
    return (
        <form noValidate autoComplete="off">
            <Grid>
                <Row>
                    <Cell columns={12}>
                        <Select
                            required={true}
                            label="Channel"
                            name="channel"
                            outlined={true}
                            className="full-width"
                            value={newDelivery.channel}
                            onChange={handleTextChange}
                            disabled={loading}
                            options={[
                                {
                                    label: 'Please choose a channel',
                                    value: '',
                                },
                                {
                                    label: 'Mobile',
                                    value: 'mobile',
                                },
                                {
                                    label: 'Kiosk',
                                    value: 'kiosk',
                                },
                                {
                                    label: 'Web',
                                    value: 'web',
                                },
                            ]}
                        />
                    </Cell>
                </Row>
                <br />
                <Row>
                    <Cell columns={12}>
                        <Select
                            required={true}
                            label="Store"
                            name="store"
                            outlined={true}
                            className="full-width"
                            value={newDelivery.store}
                            onChange={handleTextChange}
                            disabled={loading}
                            options={[
                                {
                                    label: 'Please choose a store',
                                    value: '',
                                },
                                {
                                    label: 'Blacks',
                                    value: 'blacks',
                                },
                                {
                                    label: 'Footpatrol',
                                    value: 'footpatrol',
                                },
                                {
                                    label: 'Jdplc',
                                    value: 'jdplc',
                                },
                                {
                                    label: 'Jdsports',
                                    value: 'jdsports',
                                },
                                {
                                    label: 'Millets',
                                    value: 'millets',
                                },
                                {
                                    label: 'Scotts',
                                    value: 'scotts',
                                },
                                {
                                    label: 'Size',
                                    value: 'size',
                                },
                                {
                                    label: 'Tessuti',
                                    value: 'tessuti',
                                },
                                {
                                    label: 'Ultimateoutdoors',
                                    value: 'ultimateoutdoors',
                                },
                            ]}
                        />
                    </Cell>
                </Row>
                <Row className="top-margin">
                    <Cell columns={12}>
                        <TextField
                            label="Carrier Code"
                            helperText={<HelperText>Enter delivery option carrier code</HelperText>}
                            outlined={true}
                            className="full-width"
                                required={true}
                                name="carrierCode"
                                type="text"
                                checked={true}
                                onChange={handleCarrierCodeChange}
                                value={newDelivery.carrierCode}
                                disabled={loading}
                            />
                    </Cell>
                </Row>
                <Row className="top-margin">
                    <Cell columns={12}>
                        <TextField
                            label="Display Name"
                            helperText={<HelperText>Enter delivery option display name</HelperText>}
                            outlined={true}
                            className="full-width"
                                required={true}
                                name="name"
                                type="text"
                                checked={true}
                                onChange={handleTextChange}
                                value={newDelivery.name}
                                disabled={loading}
                            />
                    </Cell>
                </Row>
                <Row className="top-margin">
                    <Cell columns={12}>
                        <TextField
                            label="Code"
                            helperText={<HelperText>Enter delivery option code</HelperText>}
                            outlined={true}
                            className="full-width"
                                required={true}
                                name="code"
                                type="text"
                                checked={true}
                                onChange={handleCodeChange}
                                value={newDelivery.code}
                                disabled={loading}
                            />
                    </Cell>
                </Row>
                <Row className="top-margin">
                    <Cell columns={12}>
                        <label htmlFor="active">Active</label>
                        <Checkbox
                            nativeControlId="active"
                            name="active"
                            checked={false}
                            onChange={handleTruthyChange}
                            value={newDelivery.active}
                            disabled={loading}
                        />
                    </Cell>
                </Row>
                <Row className="top-margin">
                    <Cell columns={12}>
                        <TextField
                            label="Description"
                            helperText={<HelperText>Enter delivery description</HelperText>}
                            outlined={true}
                            className="full-width"
                                required={true}
                                name="description"
                                type="text"
                                checked={true}
                                onChange={handleTextChange}
                                value={newDelivery.description}
                                disabled={loading}
                            />
                    </Cell>
                </Row>
                <Row className="top-margin">
                    <Cell columns={12}>
                        <TextField
                            label="Price"
                            helperText={<HelperText>Enter delivery option price</HelperText>}
                            outlined={true}
                            className="full-width"
                                required={true}
                                name="price"
                                step="0.01"
                                min="0.0"
                                type="number"
                                checked={true}
                                onChange={e => handleNumberChange(e)}
                                value={newDelivery.price}
                                disabled={loading}
                            />
                    </Cell>
                </Row>
                <Row className="top-margin">
                    <Cell columns={12}>
                        <Select
                            required={true}
                            label="Delivery Type"
                            name="deliveryType"
                            outlined={true}
                            className="full-width"
                            value={newDelivery.deliveryType}
                            onChange={handleTextChange}
                            disabled={loading}
                            options={[
                                {
                                    label: 'Please choose a delivery type',
                                    value: '',
                                },
                                {
                                    label: 'Home',
                                    value: 'home',
                                },
                                {
                                    label: 'Store',
                                    value: 'store',
                                },
                            ]}
                        />
                    </Cell>
                </Row>
                <Row className="top-margin">
                    <Cell columns={12}>
                        <TextField
                            label="Time Restriction"
                            helperText={
                                <HelperText>Enter delivery option time restriction</HelperText>
                            }
                            outlined={true}
                            className="full-width"
                                name="cutOffTime"
                                type="time"
                                onChange={handleTimeRestrictionChange}
                                value={convertTimeFromSeconds(newDelivery.cutOffTime)}
                                disabled={loading}
                            />
                    </Cell>
                </Row>
            </Grid>
        </form>
    );

    function handleCarrierCodeChange(e) {
        let { name, value } = e.target;
        console.log('value', value);
        let result = value.replace(/\s+/g, '').toUpperCase();
        deliveryOptionChanged(name, result);
    }

    function handleCodeChange(e) {
        let { name, value } = e.target;
        let result = value.toUpperCase();
        deliveryOptionChanged(name, result);
    }

    function handleTextChange(event) {
        let { name, value } = event.target;

        deliveryOptionChanged(name, value);
    }

    function handleTruthyChange(event) {
        let { name, checked } = event.target;

        deliveryOptionChanged(name, checked);
    }

    function handleTimeRestrictionChange(e) {
        let { name, value } = e.target;
        const seconds = convertTimeToSeconds(value);

        deliveryOptionChanged(name, seconds);
    }

    function handleNumberChange(event) {
        let { name, value } = event.target;
        deliveryOptionChanged(name, parseFloat(value));
    }
};

export default DeliveryOptionForm;
